import {Fragment} from 'react';

import {EmailTemplateService as Service} from './EmailTemplateService';

import {useToolbar} from '../../../shared/hooks/Toolbar';
import {useDataTable} from '../../../shared/hooks/DataTable';
import {useDialogCrup} from '../../../shared/hooks/DialogCrup';

export const List = () => {

  const header = 'Mẫu Email';
  const dataKey = 'id';

  const sendTypes = [
    {value: 1, label: 'Gửi hóa đơn'}, {value: 2, label: 'Gửi xác nhận'}, {value: 3, label: 'Gửi tài khoản'},
    {value: 4, label: 'Thông báo sai sót'}
  ];

  const {render: renderDataTable, refreshLazyData, reloadLazyData, selectedItems} = useDataTable({
    header,
    dataKey,
    columns: [
      {field: 'subject', header: 'Tiêu đề', minWidth: 200, matchMode: 'contains'},
      {field: 'isUse', header: 'Sử dụng', width: 100, dataType: 'boolean'},
      {field: 'sendType', header: 'Loại nghiệp vụ', width: 180, filterOptions: sendTypes, dataType: 'fromFilterOptions'},
    ],
    actionColumnWidth: 0,
    getList: (params) => {
      return Service.getList(params);
    }
  });

  const {render: renderDialogCrup, create, update, clone} = useDialogCrup({
    header,
    dataKey,
    width: '80rem',
    fields: [
      {field: 'subject', header: 'Tiêu đề', required: true, InputTextProps: {maxLength: 100}, className: 'md:col-12'},
      {field: 'contentEmail', header: '', required: true, type: 'CKEditor', className: 'md:col-12'},
      {field: 'sendType', header: 'Loại nghiệp vụ', type: 'Dropdown', DropdownProps: {options: sendTypes}, className: 'md:col-6'},
      {field: 'isUse', header: 'Sử dụng', type: 'Checkbox', className: 'md:col-6 pt-6'}
    ],
    createItem: (item) => {
      return Service.create(item);
    },
    updateItem: (id, item) => {
      return Service.update(id, item);
    },
    refreshLazyData
  });

  const {renderToolbar} = useToolbar({
    dataKey, create, update, clone, reloadLazyData, selectedItems,
    deleteItem: (id) => {
      return Service.delete(id);
    }
  });

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {renderDialogCrup()}
    </Fragment>
  )
}
